export function setParams(params) {
  const query = paramsToQuery(params);
  window.history.replaceState(null, "", `?${query}`);
}

export function getParams(search = window.location.search) {
  return queryToParams(search.slice(1));
}

/** Parse a query value: JSON when it looks encoded that way, otherwise plain string. */
function parseQueryValue(decodedValue) {
  if (decodedValue == null || decodedValue === "") {
    return decodedValue;
  }
  const first = decodedValue[0];
  const looksLikeJson =
    first === "{" ||
    first === "[" ||
    first === '"' ||
    first === "-" ||
    (first >= "0" && first <= "9") ||
    decodedValue === "true" ||
    decodedValue === "false" ||
    decodedValue === "null";
  if (!looksLikeJson) {
    return decodedValue;
  }
  try {
    return JSON.parse(decodedValue);
  } catch {
    return decodedValue;
  }
}

export function paramsToQuery(params = {}) {
  return Object.getOwnPropertyNames(params)
    .map((name) => {
      name = encodeURIComponent(name);
      const rawValue = params[name];
      const value = encodeURIComponent(JSON.stringify(rawValue));
      return rawValue ? `${name}=${value}` : "";
    })
    .filter(Boolean)
    .join("&");
}

export function queryToParams(query = "") {
  const tokens = query.split("&");
  return tokens.reduce((params, token) => {
    const [name, value] = token.split("=");
    // ignore malformed query params
    if (!name) {
      return params;
    }
    const decodedName = decodeURIComponent(name);
    const decodedValue = decodeURIComponent(value);

    return { ...params, [decodedName]: parseQueryValue(decodedValue) };
  }, {});
}
